<ion-row>
    <ion-col
            [style]="'border-left: 1px solid #fff; margin-left: ' + ((level + 1) * 15) + 'px; max-width: calc((calc(9 / var(--ion-grid-columns, 12)) * 100%) - ' + ((this.level + 1) * 15) + ')'">
        <div class="line-item-container">
            <div class="line-item-name">{{ selection.orderItem.menuItem.name }}</div>
            <div *ngIf="compact && !!selection.orderItem.total" class="line-item-price">{{ adjustedPrice(selection.orderItem.total) | currency }}
            </div>
            <div *ngIf="!compact && !selection.menuSelectionItem.priceFromItem && !selection.orderItem.priceOverride && !!selection.additionalPrice"
                 class="line-item-price">{{ adjustedPrice(selection.additionalPrice) | currency }}
            </div>
            <div *ngIf="!compact && selection.menuSelectionItem.priceFromItem && !selection.orderItem.priceOverride && !!selection.menuSelectionItem && !!selection.menuSelectionItem.menuItemPrice && !!selection.menuSelectionItem.menuItemPrice.price"
                 class="line-item-price">{{ adjustedPrice(selection.menuSelectionItem.menuItemPrice.price) | currency }}
            </div>
            <div
                    *ngIf="!compact && !selection.orderItem.total && !!selection.orderItem.selectedPrice && selection.orderItem.selectedPrice.percentageOfParent && !!parent"
                    class="line-item-price">{{
                    adjustedPrice(selection.total(!!parent.priceOverride ? parent.priceOverride : (!!parent.selectedPrice
                        ? parent.selectedPrice.price
                        : parent.total))) | currency
                }}
            </div>
            <div
                    *ngIf="!compact && !selection.orderItem.total && !!selection.orderItem.selectedPrice && selection.orderItem.selectedPrice.variable && !!selection.orderItem.priceOverride"
                    class="line-item-price">{{ adjustedPrice(selection.orderItem.priceOverride) | currency }}
            </div>

            <div *ngIf="!compact && !selection.menuSelectionItem.priceFromItem && !selection.additionalPrice && selection.menuSelectionItem.additionalPrice > 0"
                 class="line-item-price"
                 [class.remove-padding]="removePadding"
                 [class.canceled-price]="orderStatus === 'CANCELED'">{{ adjustedPrice(selection.menuSelectionItem.additionalPrice) | currency }}
            </div>

            <div *ngIf="!compact && selection.depositTotal() > 0"
                 class="line-item-price"
                 [class.remove-padding]="removePadding"
                 [class.canceled-price]="orderStatus === 'CANCELED'">{{ adjustedPrice(selection.depositTotal()) | currency }}<span
                    class="deposit-label">Deposit</span>
            </div>
            <div *ngIf="!compact && selection.orderItem.deposits > 0"
                 class="line-item-price"
                 [class.remove-padding]="removePadding"
                 [class.canceled-price]="orderStatus === 'CANCELED'">{{ adjustedPrice(selection.orderItem.deposits) | currency }}<span
                    class="deposit-label">Deposit</span></div>
        </div>
    </ion-col>
</ion-row>
<ion-row *ngIf="hasDetails()">
    <ion-col class="child">
        <bb-display-order-item [item]="selection.orderItem" [level]="level + 1" [count]="count"
                               [hideTotal]="hideTotal"
                               [hideHeader]="true"
                               [removePadding]="removePadding"></bb-display-order-item>
    </ion-col>
</ion-row>

